import { PagingRequest } from '../common/paging';

export class SubscriptionSearchModel extends PagingRequest {
    customerId: number;
}

export class PaymentSummaryDto {
    id: number;
    formattedAmount: string;
    jsAttemptedDate: string;
    paymentStatus: string;
    paymentMethod: string;
    hasReceipt: boolean;
}

export class InvoiceSummaryDto {
    invoiceId: number;
    jsCreated: string;
    jsPaid: string;
}

export class SubscriptionSummaryDto {
    id: number;
    accountTypeName: string;
    paymentType: string;
    paymentStatus: string;
    subscriptionStatus: string;
    jsExpiryDate: string;
    payments: PaymentSummaryDto[];
    showPayments: boolean;
    automaticRenewal: boolean;
    serviceType: string;
    showInvoices: boolean;
    invoices: InvoiceSummaryDto[];
    firstExpiryWarningSent: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/subscriptions/subscription.search.models.ts